import { __styles } from '@griffel/react';
import { DATA_OVERFLOWING, DATA_OVERFLOW_MENU } from '../constants';
export const useOverflowStyles = /*#__PURE__*/__styles({
  overflowMenu: {
    Brvla84: "fyfkpbf"
  },
  overflowingItems: {
    zb22lx: "f10570jf"
  }
}, {
  d: [".fyfkpbf [data-overflow-menu]{flex-shrink:0;}", ".f10570jf [data-overflowing]{display:none;}"]
});
//# sourceMappingURL=useOverflowStyles.styles.js.map